import { render } from "./PlatformSettings.vue?vue&type=template&id=7f135d88&scoped=true"
import script from "./PlatformSettings.vue?vue&type=script&lang=js"
export * from "./PlatformSettings.vue?vue&type=script&lang=js"

import "./PlatformSettings.vue?vue&type=style&index=0&id=7f135d88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f135d88"]])

export default __exports__